import type {JSONValue} from 'types';
import {AgentSubTypes} from 'types';
import {normalizeQuery} from 'api/functions';
import {mapToAgentTypeDto} from 'services/agent';
import type {AgentsCountSearchProps, SearchProps} from '../types';
import agentQuery from '../data/agentQuery.json';

const AGENT_INDEX = 'ebs-agent-alias';

export const mapAgentsCountSearchPropsToSearchProps = ({
  query,
  abortSignal,
}: AgentsCountSearchProps): SearchProps => {
  const normalizedQuery = normalizeQuery(query);

  const elasticBody: JSONValue[] = AgentSubTypes.map(subType => {
    const {query: subQuery} = JSON.parse(
      JSON.stringify(agentQuery)
        .replaceAll('${QUERY_PLACEHOLDER}', normalizedQuery)
        .replaceAll('${AGENT_TYPE_PLACEHOLDER}', mapToAgentTypeDto(subType)),
    );
    return {size: 0, query: subQuery};
  });

  return {
    target: '_msearch',
    index: AGENT_INDEX,
    elasticBody,
    abortSignal,
  };
};
